import React, { useEffect, useMemo, useState } from "react";
import styles from "./equip-selector-modal.module.css";
import FilterSelect from "../../filter-select/filter-select";
import Decimal from "decimal.js";
import { getUIText } from "../../../translation";
import { EQUIP_PART_TYPE, NORMAL_STATUS_TYPE } from "../../../constants";
import { loadData } from "../../../functions/dataLoader";

// const STAT_TYPE = {
//     atk: "공격력",
//     hp: "생명력",
//     def: "방어력",
//     spd: "속도",
//     crit_rate: "치명타 확률",
//     crit_dmg: "치명타 대미지",
//     eff_rate: "효과 적중",
//     eff_resist: "효과 저항",
// };

export default function EquipSelectorModal({ lang, editingEquip, setEditingEquip, setEquip }) {
    const [editing, setEditing] = useState(editingEquip ? structuredClone(editingEquip) : null);

    const [equipOrigin, setEquipOrigin] = useState(null);
    const [subOptionsOrigin, setSubOptionsOrigin] = useState(null);
    const [setOrigin, setSetEquipOrigin] = useState(null);

    useEffect(() => {
        loadData("equipments.json").then(setEquipOrigin);
        loadData("equipments_sub_options.json").then(setSubOptionsOrigin);
        loadData("equipments_sets.json").then(setSetEquipOrigin);
    }, []);

    useEffect(() => {
        if (editingEquip) {
            setEditing(structuredClone(editingEquip));
        }
    }, [editingEquip]);

    const tierFilterList = useMemo(() => {
        return [
            { name: getUIText(lang, "simulator.modal.equip.tier.1"), value: 1 },
            { name: getUIText(lang, "simulator.modal.equip.tier.2"), value: 2 },
        ];
    }, [lang]);

    const gradeFilterList = useMemo(() => {
        return [
            { name: getUIText(lang, "simulator.modal.equip.grade.unique"), value: 2 },
            { name: getUIText(lang, "simulator.modal.equip.grade.legendary"), value: 3 },
        ];
    }, [lang]);

    const setFilterList = useMemo(() => {
        if (!setOrigin)
            return [
                {
                    name: "initial",
                    value: 0,
                },
            ];

        return setOrigin.map((set) => {
            return {
                name: set.name[lang],
                value: set.id,
            };
        });
    }, [lang, setOrigin]);

    const enhanceFilterList = useMemo(() => {
        return new Array(16).fill(null, 0, 16).map((_, index) => {
            return {
                name: `+${index}`,
                value: index,
            };
        });
    }, []);

    const subOptionCount = !editing ? 0 : editing.grade === 2 ? 3 : 4;
    const optionFilterObject = useMemo(() => {
        const result = {
            main: null,
            sub: {
                0: null,
                1: null,
                2: null,
                3: null,
            },
        };

        if (!editing) return result;
        // if (!equipOrigin) {
        //     result.main = [
        //         {
        //             name: `${NORMAL_STATUS_TYPE[editing.mainOption.statType][lang]}${!editing.mainOption.statType.includes("_") && editing.mainOption.isPercent ? "%" : ""}`,
        //             value: editing.mainOption.statType,
        //             isPercent: editing.mainOption.isPercent,
        //             baseValue: editing.mainOption.baseValue,
        //             gap: editing.mainOption.gap,
        //         },
        //     ];

        //     return result;
        // }

        const equips = equipOrigin.filter(
            (e) => e.grade === editing.grade && e.part === editing.part && e.tier === editing.tier && e.set_id === editing.setId,
        );

        if (equips.length > 1) {
            throw new Error(
                `too many equips: grade - ${editing.grade}, part - ${editing.part}, tier - ${editing.tier}, setId - ${editing.setId}`,
            );
        }

        result.main = equips[0].main_stats.map((stat) => {
            return {
                name: `${NORMAL_STATUS_TYPE[stat.type][lang]}${!stat.type.includes("_") && stat.is_percent ? "%" : ""}`,
                value: stat.type,
                isPercent: stat.is_percent,
                baseValue: stat.init_value,
                gap: stat.gap,
            };
        });

        const first = subOptionsOrigin[editing.tier - 1].stats
            .filter((stat) => {
                if (stat.type === editing.mainOption.statType && stat.is_percent === editing.mainOption.isPercent) return false;
                return true;
            })
            .map((stat) => {
                return {
                    name: `${NORMAL_STATUS_TYPE[stat.type][lang]}${!stat.type.includes("_") && stat.is_percent ? "%" : ""}`,
                    value: stat.type,
                    isPercent: stat.is_percent,
                    values: stat.values,
                };
            });

        const second = first.filter(
            (e) => !(e.value === editing.subOptions[0].statType && e.isPercent === editing.subOptions[0].isPercent),
        );
        const third = second.filter(
            (e) => !(e.value === editing.subOptions[1].statType && e.isPercent === editing.subOptions[1].isPercent),
        );
        const fourth = third.filter(
            (e) => !(e.value === editing.subOptions[2].statType && e.isPercent === editing.subOptions[2].isPercent),
        );

        result.sub[0] = first;
        result.sub[1] = second;
        result.sub[2] = third;
        result.sub[3] = fourth;

        return result;
    }, [editing?.tier, editing?.grade, editing?.setId, editing?.part, editing?.mainOption]);

    // const enhancedOptionCount = !editing ? 0 : Math.floor(editing.enhanced / 3);
    // const enhancedOptionList = useMemo(() => {
    //     if (!editing) return [];

    //     return subOptionsOrigin[editing.tier - 1].stats
    //         .filter((stat) => {
    //             if (editing.subOptions.find((e) => e.statType === stat.type && e.isPercent === stat.is_percent)) return true;
    //             return false;
    //         })
    //         .map((stat) => {
    //             return {
    //                 name: `${STAT_TYPE[stat.type]}${!stat.type.includes("_") && stat.is_percent ? "%" : ""}`,
    //                 value: stat.type,
    //                 isPercent: stat.is_percent,
    //                 values: stat.values.map((value) => {
    //                     return {
    //                         name: `+${stat.is_percent ? value / 100 : value}${stat.is_percent ? "%" : ""}`,
    //                         value,
    //                     };
    //                 }),
    //             };
    //         });
    // }, [editing?.tier, editing?.subOptions]);

    // subOptions 보정
    // - mainOption과 중복 제거
    // - 등급에 맞게 갯수 조정
    // - 각 옵션의 value가 유효하지 않으면 첫 번째 값으로
    const fixSubOptions = (equip) => {
        const pool = subOptionsOrigin[equip.tier - 1].stats.filter(
            (s) => !(s.type === equip.mainOption.statType && s.is_percent === equip.mainOption.isPercent),
        );

        const targetCount = equip.grade === 2 ? 3 : 4;
        const result = [];

        // 기존 옵션 중 유효한 것 먼저 채우기
        for (const opt of equip.subOptions) {
            if (result.length >= targetCount) break;

            const found = pool.find((s) => s.type === opt.statType && s.is_percent === opt.isPercent);
            // 이미 result에 같은 타입 있으면 스킵 (중복 방지)
            const isDup = result.some((r) => r.statType === opt.statType && r.isPercent === opt.isPercent);

            if (found && !isDup) {
                const validValue = found.values.includes(opt.value) ? opt.value : found.values[0];
                result.push({ statType: found.type, isPercent: found.is_percent, value: validValue });
            }
        }

        // 부족하면 pool에서 중복 없는 것으로 채우기
        for (const s of pool) {
            if (result.length >= targetCount) break;
            const isDup = result.some((r) => r.statType === s.type && r.isPercent === s.is_percent);
            if (!isDup) {
                result.push({ statType: s.type, isPercent: s.is_percent, value: s.values[0] });
            }
        }

        return result;
    };

    // enhancedOptions 보정
    // - enhanced 단계에 맞게 슬롯 수 조정
    // - subOptions에 없는 타입은 subOptions 첫 번째로 교체
    // - value가 유효하지 않으면 첫 번째 값으로
    // const fixEnhancedOptions = (equip) => {
    //     const targetCount = Math.floor(equip.enhanced / 3);
    //     const pool = subOptionsOrigin[equip.tier - 1].stats.filter((s) =>
    //         equip.subOptions.some((opt) => opt.statType === s.type && opt.isPercent === s.is_percent),
    //     );

    //     const result = [];

    //     for (let i = 0; i < targetCount; i++) {
    //         const existing = equip.enhancedOptions[i];
    //         if (existing) {
    //             const found = pool.find((s) => s.type === existing.statType && s.is_percent === existing.isPercent);
    //             if (found) {
    //                 const validValue = found.values.includes(existing.value) ? existing.value : found.values[0];
    //                 result.push({ statType: found.type, isPercent: found.is_percent, value: validValue });
    //             } else {
    //                 // subOptions에 없는 타입이면 pool 첫 번째로 fallback
    //                 result.push({ statType: pool[0].type, isPercent: pool[0].is_percent, value: pool[0].values[0] });
    //             }
    //         } else {
    //             // 슬롯 새로 생긴 경우
    //             result.push({ statType: pool[0].type, isPercent: pool[0].is_percent, value: pool[0].values[0] });
    //         }
    //     }

    //     return result;
    // };

    const setEquipValue = (flag, value) => {
        setEditing((prev) => {
            const updated = structuredClone(prev);
            updated[flag] = value;

            // tier, grade, setId, part 변경 시 → mainOption, subOptions, enhancedOptions 재검증
            if (["tier", "grade", "setId", "part"].includes(flag)) {
                // 새 장비 데이터 찾기
                const equip = equipOrigin.find(
                    (e) => e.grade === updated.grade && e.part === updated.part && e.tier === updated.tier && e.set_id === updated.setId,
                );

                if (equip) {
                    // mainOption 보정: 기존 선택이 새 리스트에 없으면 첫 번째로
                    const validMain =
                        equip.main_stats.find(
                            (s) => s.type === updated.mainOption.statType && s.is_percent === updated.mainOption.isPercent,
                        ) ?? equip.main_stats[0];

                    updated.name = equip.name;
                    updated.img = equip.img;
                    updated.mainOption = {
                        statType: validMain.type,
                        isPercent: validMain.is_percent,
                        baseValue: validMain.init_value,
                        gap: validMain.gap,
                    };
                }

                // subOptions 보정
                updated.subOptions = fixSubOptions(updated);

                // enhancedOptions 보정
                // updated.enhancedOptions = fixEnhancedOptions(updated);
            }

            // mainOption 변경 시 → subOptions, enhancedOptions 재검증
            // (mainOption은 setEquipValue 말고 별도 setEditing으로 처리 중이지만 혹시 모르니)
            if (flag === "mainOption") {
                updated.subOptions = fixSubOptions(updated);
                // updated.enhancedOptions = fixEnhancedOptions(updated);
            }

            // enhanced 변경 시 → enhancedOptions 슬롯 수 조정
            // if (flag === "enhanced") {
            //     updated.enhancedOptions = fixEnhancedOptions(updated);
            // }

            return updated;
        });
    };

    const setEquipSubOption = (index, valueObj, valueIndex) => {
        setEditing((prev) => {
            const updated = structuredClone(prev);

            const existIndex = updated.subOptions.findIndex((e) => e.statType === valueObj.value && e.isPercent === valueObj.isPercent);

            if (existIndex !== -1 && existIndex !== index) {
                const temp = updated.subOptions[index];

                updated.subOptions[index] = {
                    statType: valueObj.value,
                    isPercent: valueObj.isPercent,
                    value: valueObj.values[0],
                };

                updated.subOptions[existIndex] = temp;
            } else if (existIndex !== -1) {
                updated.subOptions[index].value = valueObj.values[0];
            } else if (existIndex === -1) {
                updated.subOptions[index] = {
                    statType: valueObj.value,
                    isPercent: valueObj.isPercent,
                    value: valueObj.values[0],
                };
            }

            return updated;
        });
    };

    const [draftValues, setDraftValues] = useState({
        0: editing
            ? editing.subOptions[0].isPercent
                ? new Decimal(editing.subOptions[0].value).div(100).toNumber()
                : editing.subOptions[0].value
            : 0,
        1: editing
            ? editing.subOptions[1].isPercent
                ? new Decimal(editing.subOptions[1].value).div(100).toNumber()
                : editing.subOptions[1].value
            : 0,
        2: editing
            ? editing.subOptions[2].isPercent
                ? new Decimal(editing.subOptions[2].value).div(100).toNumber()
                : editing.subOptions[2].value
            : 0,
        3: editing
            ? editing.subOptions[3]?.isPercent
                ? new Decimal(editing.subOptions[3].value).div(100).toNumber()
                : editing.subOptions[3]?.value
            : 0,
    });

    useEffect(() => {
        if (!editing) return;

        setDraftValues({
            0: editing
                ? editing.subOptions[0].isPercent
                    ? new Decimal(editing.subOptions[0].value).div(100).toNumber()
                    : editing.subOptions[0].value
                : 0,
            1: editing
                ? editing.subOptions[1].isPercent
                    ? new Decimal(editing.subOptions[1].value).div(100).toNumber()
                    : editing.subOptions[1].value
                : 0,
            2: editing
                ? editing.subOptions[2].isPercent
                    ? new Decimal(editing.subOptions[2].value).div(100).toNumber()
                    : editing.subOptions[2].value
                : 0,
            3: editing
                ? editing.subOptions[3]?.isPercent
                    ? new Decimal(editing.subOptions[3].value).div(100).toNumber()
                    : editing.subOptions[3]?.value
                : 0,
        });
    }, [editing]);

    const setEquipSubOptionValue = (index, value) => {
        setEditing((prev) => {
            const updated = structuredClone(prev);
            let num = parseFloat(value);
            if (isNaN(num) || num < 0) num = 0;
            if (updated.subOptions[index].isPercent) num = parseInt(new Decimal(num).times(100).toNumber());
            else num = parseInt(num);

            updated.subOptions[index].value = num;

            return updated;
        });
    };

    // const setEquipEnhancedOption = (index, valueObj, valueIndex) => {
    //     setEditing((prev) => {
    //         const updated = structuredClone(prev);

    //         updated.enhancedOptions[index] = {
    //             statType: valueObj.value,
    //             isPercent: valueObj.isPercent,
    //             value: valueObj.values[valueIndex].value,
    //         };

    //         return updated;
    //     });
    // };

    // const setEquipEnhancedOptionValue = (index, value) => {
    //     setEditing((prev) => {
    //         const updated = structuredClone(prev);

    //         updated.enhancedOptions[index].value = value;

    //         return updated;
    //     });
    // };

    const submitEquip = (equip) => {
        setEquip(equip);
        setEditingEquip(null);
    };
    if (!equipOrigin || !subOptionsOrigin || !setOrigin) return;

    return (
        <div
            className={`modal items overflow ${editingEquip !== null ? "active" : ""}`}
            // onClick={(e) => {
            //     if (e.target.classList.contains("modal")) {
            //         setEditingEquip(null);
            //     }
            // }}
        >
            <div className="window">
                <button className="close-button" onClick={() => setEditingEquip(null)}>
                    <i className="fi fi-sr-x" />
                </button>
                {editing !== null && (
                    <div className={styles["equip-selector-container"]}>
                        <div className={styles["title"]}>
                            {EQUIP_PART_TYPE[editing.part][lang]} {getUIText(lang, "simulator.modal.equip.title")}
                        </div>
                        <div className={styles["base-setter"]}>
                            {/* <div className={styles["base-setter"]}></div> */}
                            <FilterSelect
                                id={"equip_selector_tier"}
                                list={tierFilterList}
                                selected={tierFilterList.find((e) => e.value === editing.tier)}
                                forceSmallPadding={true}
                                isUseDispatch={false}
                                changeFilter={(obj) => setEquipValue("tier", obj.value)}
                            />
                            <FilterSelect
                                id={"equip_selector_grade"}
                                list={gradeFilterList}
                                selected={gradeFilterList.find((e) => e.value === editing.grade)}
                                forceSmallPadding={true}
                                isUseDispatch={false}
                                changeFilter={(obj) => setEquipValue("grade", obj.value)}
                            />
                            <FilterSelect
                                id={"equip_selector_set"}
                                list={setFilterList}
                                selected={setFilterList.find((e) => e.value === editing.setId) || setFilterList[0]}
                                forceSmallPadding={true}
                                isUseDispatch={false}
                                changeFilter={(obj) => setEquipValue("setId", obj.value)}
                            />
                            <FilterSelect
                                id={"equip_selector_enhance"}
                                list={enhanceFilterList}
                                selected={enhanceFilterList.find((e) => e.value === editing.enhanced)}
                                forceSmallPadding={true}
                                isUseDispatch={false}
                                changeFilter={(obj) => setEquipValue("enhanced", obj.value)}
                            />
                        </div>
                        <button
                            type="button"
                            className={`${styles["is-engraved"]} ${editing.isEngraved ? `${styles["active"]}` : ""}`}
                            onClick={() => {
                                setEditing((prev) => {
                                    const updated = structuredClone(prev);
                                    updated.isEngraved = !prev.isEngraved;

                                    return updated;
                                });
                            }}
                        >
                            <i className={`fi ${editing.isEngraved ? "fi-rr-checkbox" : "fi-rr-square"}`} />
                            <span>{getUIText(lang, "simulator.modal.equip.grade.engrave")}</span>
                        </button>
                        <div className={styles["option-setter"]}>
                            <div className={styles["option"]}>
                                <div className={styles["title"]}>
                                    {getUIText(lang, "simulator.modal.equip.option.main.title")}
                                    <FilterSelect
                                        id={"equip_selector_main_option_type"}
                                        list={optionFilterObject.main}
                                        selected={optionFilterObject.main?.find(
                                            (e) => e.value === editing.mainOption.statType && e.isPercent === editing.mainOption.isPercent,
                                        )}
                                        forceWidth={"120px"}
                                        forceSmallPadding={true}
                                        isUseDispatch={false}
                                        mode={"modal"}
                                        changeFilter={(obj) => {
                                            setEditing((prev) => {
                                                const updated = structuredClone(prev);
                                                updated.mainOption = {
                                                    statType: obj.value,
                                                    isPercent: obj.isPercent,
                                                    baseValue: obj.baseValue,
                                                    gap: obj.gap,
                                                };
                                                updated.subOptions = fixSubOptions(updated);
                                                // updated.enhancedOptions = fixEnhancedOptions(updated);
                                                return updated;
                                            });
                                        }}
                                    />
                                </div>
                                <div className={styles["value"]}>
                                    +
                                    {(editing.mainOption.baseValue +
                                        editing.mainOption.gap * (editing.enhanced + (editing.isEngraved ? 3 : 0))) /
                                        (editing.mainOption.isPercent ? 100 : 1)}
                                    {editing.mainOption.isPercent ? "%" : ""}
                                </div>
                            </div>
                            {subOptionCount !== 0 &&
                                new Array(subOptionCount).fill(null, 0, subOptionCount).map((_, index) => {
                                    const subTypeList = optionFilterObject.sub[index];
                                    const subTypeSelected = subTypeList?.find(
                                        (e) =>
                                            e.value === editing.subOptions[index].statType &&
                                            e.isPercent === editing.subOptions[index].isPercent,
                                    );

                                    if (!subTypeSelected) return null;

                                    // const subValueList = subTypeSelected.values;
                                    // const subValueSelected = subValueList.find((e) => e.value === editing.subOptions[index].value);

                                    // if (!subValueSelected) return null;

                                    return (
                                        <div className={styles["option"]} key={`equip_option_${index}`}>
                                            <div className={styles["title"]}>
                                                {getUIText(lang, "simulator.modal.equip.option.sub.title")}
                                                <FilterSelect
                                                    id={"equip_selector_sub_option_type"}
                                                    list={subTypeList}
                                                    selected={subTypeSelected}
                                                    forceWidth={"120px"}
                                                    forceSmallPadding={true}
                                                    isUseDispatch={false}
                                                    mode={"modal"}
                                                    changeFilter={(obj) => setEquipSubOption(index, obj, 0)}
                                                />
                                            </div>
                                            <div className={styles["value"]}>
                                                <input
                                                    type="number"
                                                    value={draftValues[index]}
                                                    onChange={(e) => {
                                                        setDraftValues((prev) => {
                                                            const updated = structuredClone(prev);
                                                            let value = e.target.value.replaceAll(/[eE+\-]/g, "");

                                                            updated[index] = value;

                                                            return updated;
                                                        });
                                                    }}
                                                    onBlur={(e) => setEquipSubOptionValue(index, e.target.value)}
                                                />
                                                {editing.subOptions[index].isPercent && (
                                                    <div className={styles["percent-icon"]}>
                                                        <i className="fi fi-rr-percentage" />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                        <div className={styles["buttons"]}>
                            <button type="button" className={styles["submit-button"]} onClick={() => submitEquip(editing)}>
                                {getUIText(lang, "simulator.modal.tactics.confirm")}
                            </button>
                            <button type="button" className={styles["cancel-button"]} onClick={() => setEditingEquip(null)}>
                                {getUIText(lang, "simulator.modal.tactics.cancel")}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
